export default __webpack_public_path__ + "locales/si/DeleteSelfProfileDialog.json?hash=2359cb8f976b28d346727aba8d3d415c";